import {Box, Button, Divider, Grid, Typography} from '@mui/material';
import {isPast} from 'date-fns';
import {FormikErrors} from 'formik';
import {merge, set} from 'lodash';
import {enqueueSnackbar, useSnackbar} from 'notistack';
import React, {useEffect, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import AutoField, {
  ActionType,
  DatePickerField,
} from '../../components/AutoForm/AutoFieldNew';
import {AutoFormProps} from '../../components/AutoForm/AutoFormNew';
import {FixedFooter} from '../../components/Layout/Layout';
import {useAddAccountContext} from './AddAccountContext';
import {UPDATES} from '../../shared/UPDATES';
import {
  titleField,
  firstNameField,
  lastNameField,
  knownAsField,
  nationalInsuranceField,
  emailField,
  mobileField,
  LeadFormPersonValues,
  LeadFormValues,
  trustStartDateField,
  trustTypeField,
  companyNameField,
  companyNumberField,
  nationality,
  adviserField,
  singleJointField,
  taxDomicile,
  taxResidency,
  middleNameField,
} from './addAccountFields';
import {useListStaff} from '../../hooks/useListStaff';
import useTitle from '../../hooks/useTitle';
import {useAutoForm, useAutoField} from '../../components/AutoForm/useAutoForm';
import {newUTCDate} from '../../utils/newUTCDate';

export const AddLeadPerson: React.FC<{personType: 'primary' | 'secondary'}> = ({
  personType,
}) => {
  const [adviserFormik, adviserMeta, adviserHelpers] = useAutoField('adviser');
  // const [nationalityFormik, _, nationalityHelpers] = useAutoField<
  //   LeadFormPersonValues['nationality']
  // >(`${personType}.nationality`);
  // const [taxResidencyFormik, __, taxResidencyHelpers] = useAutoField<
  //   LeadFormPersonValues['taxResidency']
  // >(`${personType}.taxResidency`);
  // const [taxDomicileFormik, ___, taxDomicileHelpers] = useAutoField<
  //   LeadFormPersonValues['taxDomicile']
  // >(`${personType}.taxDomicile`);
  const {staffSelectOptions, loggedInUser} = useListStaff('adviser');

  useEffect(() => {
    if (loggedInUser?.isAdviser && !adviserFormik.value) {
      adviserHelpers.setValue(UPDATES._1605, loggedInUser.id);
    }
  }, [loggedInUser]);

  // useEffect(() => {
  //   if (!nationalityFormik.value) {
  //     nationalityHelpers.setValue('United Kingdom');
  //   }
  // }, [nationalityFormik.value]);

  // useEffect(() => {
  //   if (!taxResidencyFormik.value) {
  //     taxResidencyHelpers.setValue('United Kingdom');
  //   }
  // }, [taxResidencyFormik.value]);

  // useEffect(() => {
  //   if (!taxDomicileFormik.value) {
  //     taxDomicileHelpers.setValue('United Kingdom');
  //   }
  // }, [taxDomicileFormik.value]);

  const dobField = useMemo<DatePickerField>(() => {
    return {
      id: `${personType}.dob`,
      label: 'DOB (DD/MM/YYYY) *',
      type: ActionType.datepicker,
      fullWidth: true,
      private: true,
    };
  }, []);

  return (
    <>
      <Grid item>
        <AutoField field={{...titleField, id: `${personType}.${titleField.id}`}} />
      </Grid>
      <Grid item>
        <AutoField
          field={{...firstNameField, id: `${personType}.${firstNameField.id}`}}
        />
      </Grid>
      <Grid item>
        <AutoField
          field={{...middleNameField, id: `${personType}.${middleNameField.id}`}}
        />
      </Grid>
      <Grid item>
        <AutoField field={{...lastNameField, id: `${personType}.${lastNameField.id}`}} />
      </Grid>
      <Grid item>
        <AutoField field={{...knownAsField, id: `${personType}.${knownAsField.id}`}} />
      </Grid>
      <Grid item>
        <AutoField
          field={{
            ...adviserField,
            id: `adviser`,
            options: staffSelectOptions.length
              ? staffSelectOptions
              : [{label: 'No adviser/paraplanner available', value: ''}],
          }}
        />
      </Grid>
      <Grid item>
        <AutoField field={dobField} />
      </Grid>
      <Grid item>
        <AutoField
          field={{
            ...nationalInsuranceField,
            id: `${personType}.${nationalInsuranceField.id}`,
          }}
        />
      </Grid>
      <Grid item>
        <AutoField field={{...nationality, id: `${personType}.${nationality.id}`}} />
      </Grid>
      <Grid item>
        <AutoField field={{...taxDomicile, id: `${personType}.${taxDomicile.id}`}} />
      </Grid>
      <Grid item>
        <AutoField field={{...taxResidency, id: `${personType}.${taxResidency.id}`}} />
      </Grid>
      {/* <Box mt={2} />
      <Grid item>
        <Typography variant="h6">
          {personType === 'primary' ? 'Primary' : 'Secondary'} contact details :
        </Typography>
      </Grid> */}
      <Grid item>
        <AutoField field={{...emailField, id: `${personType}.${emailField.id}`}} />
      </Grid>
      <Grid item>
        <AutoField field={{...mobileField, id: `${personType}.${mobileField.id}`}} />
      </Grid>

      {/* <Grid item>
        <AutoField
          field={{...homePhoneField, id: `${personType}.${homePhoneField.id}`}}
        />
      </Grid> */}
    </>
  );
};

const validatePerson = (
  person: LeadFormPersonValues,
  prefix: 'primary' | 'secondary',
  errors: FormikErrors<LeadFormValues>
): FormikErrors<LeadFormValues> => {
  if (!person.firstName) {
    set(errors, `${prefix}.firstName`, 'Required');
  }
  if (!person.title) {
    set(errors, `${prefix}.title`, 'Required');
  }
  if (!person.firstName) {
    set(errors, `${prefix}.firstName`, 'Required');
  }
  if (!person.lastName) {
    set(errors, `${prefix}.lastName`, 'Required');
  }
  if (!person.nationalInsurance) {
    set(errors, `${prefix}.nationalInsurance`, 'Required');
  } else if (person.nationalInsurance.length > 13) {
    set(errors, `${prefix}.nationalInsurance`, 'Max 13 characters');
  }
  if (!person.dob) {
    set(errors, `${prefix}.dob`, 'Required');
    // errors.moveInDate = 'Required';
  } else if (isPast(newUTCDate(person.dob))) {
    // all good
  } else {
    set(errors, `${prefix}.dob`, 'Must be in the past');
  }
  if (!person.primaryEmail) {
    set(errors, `${prefix}.primaryEmail`, 'Required');
  }
  // if (!person.homePhone && !person.mobilePhone) {
  //   set(errors, `${prefix}.contactError`, 'At least one is required');
  //   set(errors, `${prefix}.mobilePhone`, 'Required');
  // }

  return errors;
};

const validateBasic = (values: LeadFormValues): FormikErrors<LeadFormValues> => {
  const errors: FormikErrors<LeadFormValues> = {};

  if (!values.accountType) {
    set(errors, 'accountType', 'Required');
  }

  validatePerson(values.primary || {}, 'primary', errors);
  if (values.singleJoint === 'joint') {
    validatePerson(values.secondary! || {}, 'secondary', errors);
    if (
      values.secondary!.primaryEmail &&
      values.secondary!.primaryEmail === values.primary.primaryEmail
    ) {
      set(errors, `secondary.primaryEmail`, 'Emails cannot be the same');
      enqueueSnackbar({message: 'Contact emails cannot be the same', variant: 'error'});
    }
  }

  if (!values.adviser) {
    set(errors, `adviser`, 'Required');
  }

  if (values.accountType === 'Corporate') {
    if (!values.companyName) {
      set(errors, `companyName`, 'Required');
    }
    if (!values.companyNumber) {
      set(errors, `companyNumber`, 'Required');
    }
  }
  if (values.accountType === 'Trust') {
    if (!values.trustStartDate) {
      set(errors, `trustStartDate`, 'Required');
    }
    if (!values.trustType) {
      set(errors, `trustType`, 'Required');
    }
  }
  return errors;
};

export const AddAccountRedirect: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({pathname: './basic'});
  }, []);
  return null;
};

export const AddAccountBasicForm: React.FC<AutoFormProps<LeadFormValues>> = () => {
  useTitle(`Create client`);
  const navigate = useNavigate();
  const {closeSnackbar} = useSnackbar();
  const {goToStep} = useAddAccountContext();
  const {values, handleSubmit, errors, setErrors, setValues} =
    useAutoForm<LeadFormValues>();
  const showSecondary = values.singleJoint === 'joint';
  useEffect(() => {
    goToStep('basic');
  }, []);

  const householdFormInputs = (
    <>
      <Grid item>
        <Typography variant="h6">Primary client details:</Typography>
      </Grid>
      <AddLeadPerson personType="primary" />
      <Box mt={4} />
      {showSecondary ? (
        <>
          <Divider />
          <Box mt={4} />
          <Grid item>
            <Typography variant="h6">Secondary client details:</Typography>
          </Grid>
          <AddLeadPerson personType="secondary" />
          <Box mt={2} />
          {/* <Grid item>
            <Button
              onClick={() => setShowSecondary(false)}
              variant="outlined"
              color="secondary"
            >
              Remove secondary
            </Button>
          </Grid> */}
        </>
      ) : null}
    </>
  );

  const trustInputs =
    values.accountType === 'Trust' ? (
      <>
        <Grid item>
          <Typography variant="h6">Trust details:</Typography>
        </Grid>
        <Grid item>
          <AutoField field={trustStartDateField} />
        </Grid>
        <Grid item>
          <AutoField field={trustTypeField} />
        </Grid>
      </>
    ) : null;

  const companyInputs =
    values.accountType === 'Corporate' ? (
      <>
        <Grid item>
          <Typography variant="h6">Company details:</Typography>
        </Grid>
        <Grid item>
          <AutoField field={companyNameField} />
        </Grid>
        <Grid item>
          <AutoField field={companyNumberField} />
        </Grid>
      </>
    ) : null;

  return (
    <>
      <Box mt={1} mb={1} padding={3} bgcolor="white">
        <Grid container spacing={2}>
          <Grid item xs={12} md={8} lg={6}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <AutoField field={singleJointField} />
              </Grid>
              <Box mt={4} />
              {householdFormInputs}
              {trustInputs}
              {companyInputs}
            </Grid>
          </Grid>
        </Grid>
        <FixedFooter>
          <Grid justifyContent="space-between" container spacing={2}>
            <Button
              style={{opacity: 0}}
              onClick={(e) => {
                if (!e.altKey) {
                  return;
                }

                const initialValueOverrides: Partial<LeadFormValues> = {
                  accountType: 'Household',
                  country: 'United Kingdom',

                  primary: {
                    nationality: 'United Kingdom',
                    taxDomicile: 'United Kingdom',
                    taxResidency: 'United Kingdom',
                    title: 'Mr',
                    firstName: 'Saturnino Test',
                    middleName: 'Lemon',
                    lastName: 'Harris',
                    primaryEmail: 'saturninoharris@gmail.com',
                    mobilePhone: '07511833765',
                    knownAs: 'Neeno',
                    nationalInsurance: '12345',
                    dob: '1993-11-16T00:00:00.000Z',
                    // ...(values.primary as any),
                  } as LeadFormPersonValues,

                  agree: true,
                  businessUnitId: values.businessUnitId,
                  secondary: {
                    title: 'Mrs',
                    firstName: 'Abigail test',
                    middleName: 'Orange',
                    lastName: 'Test',
                    primaryEmail: 'saturninoharristwo@gmail.com',
                    mobilePhone: '07511833765',
                    knownAs: 'Test ms',
                    dob: '1993-11-16T00:00:00.000Z',
                    nationalInsurance: '1234',
                    nationality: 'United Kingdom',
                    taxDomicile: 'United Kingdom',
                    taxResidency: 'United Kingdom',
                    // ...(values.secondary as any),
                  } as LeadFormPersonValues,
                  line1: '20 yew tree road',
                  city: 'london',
                  postcode: 'w120tj',
                  ongoingFee: '0.40',
                };
                const merged = merge({}, initialValueOverrides, values, {
                  singleJoint: e.ctrlKey || e.metaKey ? 'joint' : 'single',
                  agree: true,
                }) as any;

                setValues(UPDATES._4550, () => merged, true);
                setTimeout(() => {
                  navigate('../summary');
                }, 50);
              }}
            >
              Demo
            </Button>
            <div style={{flex: 1}} />
            {/* <Button
            onClick={() => {
              closeSnackbar();
              const newErrors = validateBasic(values);
              setErrors(newErrors);
              if (Object.keys(newErrors).length) {
                enqueueSnackbar(
                  `Some fields are missing. Please complete before saving.`,
                  {variant: 'error'}
                );
              } else {
                onCreateOrUpdate(values).then(() => {
                  navigate('/search');
                });
              }
            }}
            variant="contained"
            color="primary"
          >
            {saving ? 'Saving...' : 'Save and exit'}
          </Button> */}
            <Button
              variant="contained"
              color="primary"
              // disabled={onCreateOrUpdateLoading}
              onClick={() => {
                closeSnackbar();
                const newErrors = validateBasic(values);
                setErrors(newErrors);
                if (Object.keys(newErrors).length) {
                  enqueueSnackbar(
                    `Some fields are missing. Please complete before saving.`,
                    {variant: 'error'}
                  );
                } else {
                  // onCreateOrUpdate(values).then((leadId) =>
                  //   navigate(`/add-account/address`)
                  //   );
                  navigate(`/add-account/address`);
                }
              }}
            >
              Next
            </Button>
          </Grid>
        </FixedFooter>
      </Box>
    </>
  );
};

// const AddLeadFormWrapped = withAutoFormNew<LeadFormValues, {}>(div);

// export const AddLead: React.FC = () => {
//   const {lead, onCreateOrUpdate} = useLeadContext();
//   const navigate = useNavigate();
//   useScrollToTop();
//   const initialValueOverrides: Partial<LeadFormValues> = useMemo(() => {
//     return {
//       accountId: lead?.account?.id || undefined,
//       accountName: lead?.accountName || undefined,
//       accountType: lead?.accountType || undefined,

//       companyName: lead?.companyName || undefined,
//       contactId: lead?.contact?.id || undefined,
//       dob: lead?.dob || undefined,
//       firstName: lead?.firstName || undefined,
//       lastName: lead?.lastName || undefined,
//       leadSource: lead?.leadSource || undefined,
//       jobTitle: lead?.jobTitle || undefined,
//       // adviserId: lead?.adviserId || undefined,
//       homePhone: lead?.homePhone || undefined,
//       mobilePhone: lead?.mobilePhone || undefined,
//       leadId: lead?.id || undefined,
//       linkedinProfile: lead?.linkedinProfile || undefined,
//       nationalInsurance: lead?.nationalInsurance || undefined,
//       primaryEmail: lead?.primaryEmail || undefined,
//       secondaryEmail: lead?.secondaryEmail || undefined,
//       title: lead?.title || undefined,
//       // addresses
//       addresses: [
//         {
//           address1: '',
//           address2: '',
//           address3: '',
//           county: '',
//           moveInDate: newUTCDate(),
//           postcode: '',
//           town: '',
//         },
//       ],
//     };
//   }, [lead]);

//   return (
//     <>
//       <AddLeadFormWrapped
//         submit={(values) => {
//           navigate(`../address`);
//           // onCreateOrUpdate(values).then((leadId) => {
//           //   navigate(`./address?leadId=${leadId}`);
//           // });
//         }}
//         formFields={[]}
//         initialValueOverrides={initialValueOverrides}
//       />
//     </>
//   );
// };
